import React from 'react';
import { Route } from 'react-router';
import PropTypes from 'prop-types';

const Status = ({ code, children }) => (
  <Route
    render={({ staticContext }) => {
      if (staticContext) {
        staticContext.status = code;
      }
      return children;
    }}
  />
);

Status.propTypes = {
  code: PropTypes.string,
  children: PropTypes.node,
};

export default Status;
